<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-content">
      <ul class="o-sels j-area-select-container">
        <li
          class="o-sels_sel j-select-area"
          :data-code="index"
          @click="selectLocation(area, index)"
          v-for="(area, index) in locations"
          :key="index"
        >
          {{ area }}
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import SelectContainer from '../../mixins/twSelectContainer';

export const HIDE_AREA_SELECTOR = 'hideAreaSelector';
export default {
  props: ['locations'],

  methods: {
    selectLocation(name, value) {
      const area = {
        name: name,
        value: value,
      };
      this.$emit(HIDE_AREA_SELECTOR, area);
    },
  },
  mixins: [SelectContainer],
};
</script>

<style>
.areas-lst,
.current-area {
  padding: 0 16px;
  box-sizing: border-box;
}
</style>
